import Vue from 'vue';
import VueRouter from 'vue-router';
import $ from "jquery";
// import { getMenuList } from '@/api/menu';
// import store from '@/store/index';

// import SupportViewPage from '@/views/support/SupportViewPage.vue';

Vue.use(VueRouter);

// const requireAuth = () => async(to, from, next) => {
// console.log(Vue.prototype.$session.get('jwt-auth-token'));
//console.log('requireAuth check');
// const { data } = await getAuthCheck();
// if (Vue.prototype.$session.get('token') == '') {
//     Vue.prototype.$session.destroy();
//     next('/login');
// }
//     next();
// };

// const Login = () => import(/* webpackChunkName: 'Login' */ '@/views/LoginPage.vue');


const router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/main',
        },
        {
            path: '/main',
            component: () =>
                import ('@/views/MainPage.vue'),
        },
        {
            path: '/login',
            component: () => 
                import ('@/views/LoginPage.vue'),
        },
        {
            path: '/ssoStep1',
            component: () =>
                import ('@/components/account/SsoStep1.vue'),
        },
        {
            path: '/signup',
            component: () =>
                import ('@/views/SignupPage.vue'),
        },
        {
            path: '/validatemail/:param',
            component: () =>
                import ('@/components/account/ConfirmMail.vue'),
        },
        {
            path: '/symbollibrary',
            component: () =>
                import ('@/components/symbol/SymbolLibrary.vue'),
            meta: {
                auth: true,
            },
        },
        {
            path: '/tsg',
            component: () =>
                import ('@/components/tsg/TsgDictionary.vue'),
            name: 'tsg',
            meta: {
                auth: true,
            },
        },
        {
            path: '/dxp-tsg',
            component: () =>
                import ('@/components/tsg/TsgDictionaryForDxp.vue'),
            name: 'tsgDxp',
            meta: {
                auth: true,
            },
        },
        {
            path: '/forgot',
            component: () =>
                import ('@/views/ForgotAccount.vue'),
            name: 'forgot',
            children: [{
                    path: 'id',
                    name: 'id',
                    component: () =>
                        import ('@/components/account/ForgotId.vue'),
                },
                {
                    path: 'password',
                    name: 'password',
                    component: () =>
                        import ('@/components/account/ForgotPasswd.vue'),
                },
            ]
        },
        {
            path: '/search/',
            component: () =>
                import ('@/views/search/SearchPage.vue'),
            name: 'search',
            children: [{
                    path: 'index',
                    name: 'index',
                    component: () =>
                        import ('@/components/search/SearchPage.vue'),
                },
                {
                    path: 'pdf',
                    name: 'pdf',
                    component: () =>
                        import ('@/components/search/SearchPdf.vue'),
                },
                {
                    path: 'webhelp',
                    name: 'webhelp',
                    component: () =>
                        import ('@/components/search/SearchHtml.vue'),
                },
            ]
        },
        {
            path: '/product',
            component: () =>
                import ('@/views/product/ProductPage.vue'),
            name: 'product',
            children: [{
                    path: 'list',
                    name: 'productList',
                    component: () =>
                        import ('@/components/product/Products.vue'),
                    meta: {
                        auth: true,
                    },
                }

            ]
        },
        {
            path: '/document',
            component: () =>
                import ('@/views/document/DocumentPage.vue'),
            name: 'document',
            children: [{
                path: 'list',
                name: 'documentList',
                component: () =>
                    import ('@/components/document/Document.vue'),
                meta: {
                    auth: true,
                },
            }]
        },
        {
            path: '/support',
            component: () =>
                import ('@/views/support/SupportPage.vue'),
            name: 'support',
            children: [{
                    path: 'notice',
                    name: 'notice',
                    component: () =>
                        import ('@/components/support/Notice.vue'),

                },
                {
                    path: 'notice/detail',
                    name: 'noticeDetail',
                    component: () =>
                        import ('@/components/support/view/NoticeView.vue'),
                    // props: true,
                },
                {
                    path: 'qna',
                    name: 'qnaList',
                    component: () =>
                        import ('@/components/support/QNA.vue'),
                },
                {
                    path: 'qna/detail',
                    name: 'qnaDetail',
                    component: () =>
                        import ('@/components/support/view/QnaView.vue'),
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'qna/form',
                    name: 'qnaForm',
                    component: () =>
                        import ('@/components/support/form/QnaForm.vue'),
                    meta: {
                        auth: true,
                    },
                },
                {
                    path: 'faq',
                    name: 'faqList',
                    component: () =>
                        import ('@/components/support/FAQ.vue'),
                },
                {
                    path: 'contactus',
                    name: 'contactusList',
                    component: () =>
                        import ('@/components/support/ContactUs.vue'),
                },
            ]
        },

        {
            path: '/management',
            component: () =>
                import ('@/views/management/Management.vue'),
            name: 'management',
            children: [{
                    path: 'library/doctype',
                    name: 'mgmtDocumentType',
                    component: () =>
                        import ('@/components/management/library/DoctypeManagement.vue'),
                },
                {
                    path: 'library/product',
                    name: 'mgmtProduct',
                    component: () =>
                        import ('@/components/management/library/ProductManagement.vue'),
                },
                {
                    path: 'library/symbollibrary',
                    name: 'mgmtSymbolLibrary',
                    component: () =>
                        import ('@/components/management/library/SymbolLibraryMgmt.vue'),
                },
                {
                    path: 'library/document',
                    name: 'mgmtDocument',
                    component: () =>
                        import ('@/components/management/library/DocumentManagement.vue'),
                },
                {
                    path: 'library/document/new',
                    name: 'mgmtNewDocumnet',
                    component: () =>
                        import ('@/components/management/library/NewDocument.vue'),
                },
                {
                    path: 'library/document/details',
                    name: 'mgmtDocumentDtails',
                    component: () =>
                        import ('@/components/management/library/DocumentDetails.vue'),
                    props: true,
                },
                {
                    path: 'library/region',
                    name: 'mgmtRegion',
                    component: () =>
                        import ('@/components/management/library/ClassifyRegionsMgmt.vue'),
                },
                {
                    path: 'library/pdf',
                    name: 'mgmtPDF',
                    component: () =>
                        import ('@/components/management/library/PDFWaterMarkMgmt.vue'),
                },
                {
                    path: 'support/notice',
                    name: 'mgmtNotice',
                    component: () =>
                        import ('@/components/management/support/NoticeManagement.vue'),
                },
                {
                    path: 'support/notice/detail',
                    name: 'mgmtNoticeView',
                    component: () =>
                        import ('@/components/management/support/NoticeMgmtView.vue'),
                },
                {
                    path: 'support/notice/form',
                    name: 'mgmtNoticeForm',
                    component: () =>
                        import ('@/components/management/support/NoticeForm.vue'),
                },
                {
                    path: 'support/qna',
                    name: 'mgmtQna',
                    component: () =>
                        import ('@/components/management/support/QnaManagement.vue')
                },
                {
                    path: 'support/qna/cls',
                    name: 'mgmtQnaCls',
                    component: () =>
                        import ('@/components/management/support/QnaClsMgmt.vue')
                },
                {
                    path: 'support/qna/cls/manager',
                    name: 'mgmtQnaClsManager',
                    component: () =>
                        import ('@/components/management/support/QnaClsManager.vue')
                },
                {
                    path: 'support/qna/cls/form',
                    name: 'mgmtQnaClsForm',
                    component: () =>
                        import ('@/components/management/support/QnaClsForm.vue')
                },
                {
                    path: 'support/qna/detail',
                    name: 'mgmtQnaView',
                    component: () =>
                        import ('@/components/management/support/QnaMgmtView.vue'),
                },
                {
                    path: 'support/qna/form',
                    name: 'mgmtQnaForm',
                    component: () =>
                        import ('@/components/management/support/QnaMgmtForm.vue'),
                },
                {
                    path: 'support/faq',
                    name: 'mgmtFaq',
                    component: () =>
                        import ('@/components/management/support/FaqManagement.vue'),
                },
                {
                    path: 'support/faq/form',
                    name: 'mgmtFaqForm',
                    component: () =>
                        import ('@/components/management/support/FaqForm.vue'),
                },
                {
                    path: 'support/contact',
                    name: 'mgmtContact',
                    component: () =>
                        import ('@/components/management/support/ContactManagement.vue'),
                },
                {
                    path: 'support/contact/cls/form',
                    name: 'mgmtContactClsForm',
                    component: () =>
                        import ('@/components/management/support/ContactClsForm.vue'),
                },
                {
                    path: 'support/contact/cls/manager',
                    name: 'mgmtContactClsMemer',
                    component: () =>
                        import ('@/components/management/support/ContactClsManager.vue'),
                },
                {
                    path: 'support/feedback',
                    name: 'mgmtFeedback',
                    component: () =>
                        import ('@/components/management/support/FeedbackMgmt.vue')
                },
                {
                    path: 'support/feedback/manager',
                    name: 'mgmtFeedbackManager',
                    component: () =>
                        import ('@/components/management/support/FeedbackManager.vue')
                },
                {
                    path: 'support/relatedlink',
                    name: 'mgmtRelatedLink',
                    component: () =>
                        import ('@/components/management/support/RelatedLinksMgmt.vue')
                },
                {
                    path: 'support/relatedlink/form',
                    name: 'mgmtRelatedForm',
                    component: () =>
                        import ('@/components/management/support/RelatedLinksForm.vue')
                },
                {
                    path: 'user',
                    name: 'userMgmt',
                    component: () =>
                        import ('@/components/management/user/UserManagement.vue')
                },
                {
                    path: 'user/detail',
                    name: 'userMgmtView',
                    component: () =>
                        import ('@/components/management/user/UserMgmtDetail.vue')
                },
                {
                    path: 'role',
                    name: 'roleMgmt',
                    component: () =>
                        import ('@/components/management/user/RoleManagement.vue')
                },
                {
                    path: 'role/user',
                    name: 'roleUserMgmt',
                    component: () =>
                        import ('@/components/management/user/RoleUsersManagement.vue')
                },
                {
                    path: 'menu',
                    name: 'menuMgmt',
                    component: () =>
                        import ('@/components/management/user/MenuManagement.vue')
                },
                {
                    path: 'menu/user/list',
                    name: 'userMenuMgmt',
                    component: () =>
                        import ('@/components/management/user/UserMenuManagement.vue')
                },
                {
                    path: 'menu/role/list',
                    name: 'roleMenuMgmt',
                    component: () =>
                        import ('@/components/management/user/RoleMenuManagement.vue')
                },
                {
                    path: 'email/group',
                    name: 'emailGroupMgmt',
                    component: () =>
                        import ('@/components/management/email/EmailGroupMgmt.vue')
                },
                {
                    path: 'email/group/user',
                    name: 'emailGroupUserMgmt',
                    component: () =>
                        import ('@/components/management/email/EmailGroupUserMgmt.vue')
                },
                {
                    path: 'email/template',
                    name: 'emailTemplateMgmt',
                    component: () =>
                        import ('@/components/management/email/EmailTemplateMgmt.vue')
                },
                {
                    path: 'email/template/form',
                    name: 'emailTemplateForm',
                    component: () =>
                        import ('@/components/management/email/EmailTemplateForm.vue')
                },
                {
                    path: 'email/send',
                    name: 'emailSendMgmt',
                    component: () =>
                        import ('@/components/management/email/EmailSendMgmt.vue')
                },
                {
                    path: 'email/send/form',
                    name: 'emailSendForm',
                    component: () =>
                        import ('@/components/management/email/EmailForm.vue')
                },
                {
                    path: 'statistics/documentType',
                    name: 'mgmtStatisticsDocumentType',
                    component: () =>
                        import ('@/components/management/statistics/doctype/StatisticsDoctype.vue')
                },
                {
                    path: 'statistics/productType',
                    name: 'mgmtStatisticsProduct',
                    component: () =>
                        import ('@/components/management/statistics/product/StatisticsProduct.vue')
                },
                {
                    path: 'statistics/docDownload',
                    name: 'mgmtStatisticsDocDownload',
                    component: () =>
                        import ('@/components/management/statistics/docdownload/StatisticsDocDownload.vue')
                },
                {
                    path: 'statistics/docView',
                    name: 'mgmtStatisticsDocView',
                    component: () =>
                        import ('@/components/management/statistics/docview/StatisticsDocView.vue')
                },
                {
                    path: 'statistics/webhelp',
                    name: 'mgmtStatisticsWebhelp',
                    component: () =>
                        import ('@/components/management/statistics/webhelp/StatisticsWebHelp.vue')
                },
                {
                    path: 'statistics/accountCreate',
                    name: 'mgmtStatisticsAccountCreate',
                    component: () =>
                        import ('@/components/management/statistics/accountcreate/StatisticsAccountCreate.vue')
                },
                {
                    path: 'statistics/feedback',
                    name: 'mgmtStatisticsFeedback',
                    component: () =>
                        import ('@/components/management/statistics/feedback/StatisticsFeedback.vue')
                },
                {
                    path: 'statistics/docRatio',
                    name: 'mgmtStatisticsDocRatio',
                    component: () =>
                        import ('@/components/management/statistics/docratio/StatisticsDocRatio.vue')
                },
                {
                    path: 'statistics/userStatus',
                    name: 'mgmtStatisticsUserStatus',
                    component: () =>
                        import ('@/components/management/statistics/userstatus/StatisticsUserStatus.vue')
                },
                {
                    path: 'statistics/accessbyregion',
                    name: 'mgmtStatisticsAccessByRegion',
                    component: () =>
                        import ('@/components/management/statistics/byregion/StatisticsAccessByRegion.vue')
                },
                {
                    path: 'statistics/accessbycountry',
                    name: 'mgmtStatisticsAccessByCountry',
                    component: () =>
                        import ('@/components/management/statistics/bycountry/StatisticsAccessByCountry.vue')
                },
                {
                    path: 'statistics/accessbylanguages',
                    name: 'mgmtStatisticsAccessByLanguages',
                    component: () =>
                        import ('@/components/management/statistics/bylanguages/StatisticsAccessByLanguages.vue')
                },
                {
                    path: 'statistics/accessbytimezone',
                    name: 'mgmtStatisticsAccessByTimezone',
                    component: () =>
                        import ('@/components/management/statistics/bytimezone/StatisticsAccessByTimezone.vue')
                },
                {
                    path: 'statistics/accessbypreferencedevice',
                    name: 'mgmtStatisticsAccessByPreferenceDevice',
                    component: () =>
                        import ('@/components/management/statistics/bypreferencedevice/StatisticsAccessByPreferenceDevice.vue')
                },
                {
                    path: 'statistics/accessbymodel',
                    name: 'mgmtStatisticsAccessByModel',
                    component: () =>
                        import ('@/components/management/statistics/bymodel/StatisticsAccessByModel.vue')
                },
                {
                    path: 'statistics/recentmodel',
                    name: 'mgmtStatisticsAccessByRecentModel',
                    component: () =>
                        import ('@/components/management/statistics/byrecentmodel/StatisticsAccessByRecentModel.vue')
                },
                {
                    path: 'statistics/accessbytopic',
                    name: 'mgmtStatisticsAccessByTopic',
                    component: () =>
                        import ('@/components/management/statistics/bytopic/StatisticsAccessByTopic.vue')
                },
                {
                    path: 'statistics/accessbyfunction',
                    name: 'mgmtStatisticsAccessByFunction',
                    component: () =>
                        import ('@/components/management/statistics/byfunction/StatisticsAccessByFunction.vue')
                },
                {
                    path: 'library/tsg',
                    name: 'mgmtTsg',
                    component: () =>
                        import ('@/components/management/library/TsgManagement.vue'),
                    props: true,
                },
                {
                    path: 'library/tsg/new',
                    name: 'mgmtTsgForm',
                    component: () =>
                        import ('@/components/management/library/TsgForm.vue'),
                    props: true,
                },
            ]
        },
        {
            path: '/mylibrary',
            component: () =>
                import ('@/views/mylibrary/MyLibraryPage.vue'),
            name: 'mylibrary',
            children: [{
                    path: 'bookmarks',
                    name: 'bookmarksList',
                    component: () =>
                        import ('@/components/mylibrary/Bookmarks.vue'),
                },
                {
                    path: 'bookmarks/management',
                    name: 'bookmarkMgmt',
                    component: () =>
                        import ('@/components/mylibrary/BookmarkManagement.vue'),
                },
                {
                    path: 'myqna',
                    name: 'myqnaList',
                    component: () =>
                        import ('@/components/mylibrary/MyQna.vue'),
                },
                {
                    path: 'myqna/detail',
                    name: 'myqnaDetail',
                    component: () =>
                        import ('@/components/mylibrary/MyQnaView.vue'),
                },
                {
                    path: 'myqna/form',
                    name: 'myqnaForm',
                    component: () =>
                        import ('@/components/mylibrary/MyQnaForm.vue'),
                },
                {
                    path: 'feedback',
                    name: 'feedbackList',
                    component: () =>
                        import ('@/components/mylibrary/FeedBack.vue'),
                },
                {
                    path: 'myinfo',
                    name: 'myinfoDetail',
                    component: () =>
                        import ('@/components/mylibrary/MyInfo.vue'),
                },
            ]
        },
        {
            path: '/footer',
            component: () =>
                import ('@/views/FooterPage.vue'),
            name: 'footer',
            children: [{
                    path: 'privacypolice',
                    name: 'privacypolice',
                    component: () =>
                        import ('@/components/footer/PrivacyPolice.vue'),
                },
                {
                    path: 'termsofuse',
                    name: 'termsofuse',
                    component: () =>
                        import ('@/components/footer/TermsOfUse.vue'),
                },
                {
                    path: 'legalnotice',
                    name: 'legalnotice',
                    component: () =>
                        import ('@/components/footer/LegalNotice.vue'),
                },
            ]
        },
        {
            path: '*',
            name: 'errorPage',
            component: () =>
                import ('@/views/Error.vue')
        }
    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
        // document.getElementById('app').scrollIntoView();
    }

});

// accessToken 으로 접근할 수 있는 경로
const accessTokenAllowedPaths = ['/dxp-tsg', '/document/preview', '/tsg/preview'];

router.beforeEach(async (to, from, next) => {
    let accessToken = to.query.accessToken;
    // 24.01.23
    // /dxp-tsg로 직접 접근하고 accessToken 으로 로그인할때
    if(to.path=='/dxp-tsg' && accessToken && Vue.prototype.$session.get('loginUser') == null){
        await $.get('/api/dxp/login').then(
            user => Vue.prototype.$session.set('loginUser', user),
            token => Vue.prototype.$session.set("token", "Bearer " + token),
            err => console.error(err)
        )
    // accessToken 있는 사용자 다른 페이지 접근 제어
    // && 가 || 보다 우선해 (A && B) || C 로 묶이는 바람에 마지막 조건이 사실상
    // 항상 참이 되어, 허용 경로까지 /login 으로 튕기고 있었다.
    }else if(accessToken && !accessTokenAllowedPaths.includes(to.path)){
        next('/login');
        return; 
    }
    // 로그인 안했을때
    if (to.meta.auth && Vue.prototype.$session.get('loginUser') == null) {
        next('/login');
        return; // if 문을 타서 next 로 로그인하고 나서 또 next() 호출하게됨
    } else {
        // 로그인 됬을때 다음 페이지로
        next();
    }


});

export default router;